import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { IPostingDTO } from '../interfaces/dto/posting.dto.interface';
import { IPostingQuery } from '../interfaces/interfaces/posting.query.interface';
import { PostingCreatedBy } from './posting-created-by.model';
import { PostingTranslation } from './posting-translation.model';
import { PostingType } from './posting-type.model';

export class Posting {
    static label_singular = 'posting';
    static label_plural = 'postings';

    static props_to_search = ['contentTitle'];

    id: string;
    postingType: PostingType;
    validFrom: Date;
    validTo: Date;
    createdBy: PostingCreatedBy;
    createdAt: Date;
    url: string;
    kind: string;
    image: MaxbrainImage;
    translations: PostingTranslation[] = [];
    translation: PostingTranslation;
    article?: { id: string; uniqueId?: string };
    selected?: boolean;

    get title(): string {
        return this.translation?.title ?? this.translations?.[0]?.title ?? null;
    }

    get description(): string | null {
        return this.translation?.description ?? this.translations?.[0]?.description ?? null;
    }

    constructor(postingQuery?: IPostingQuery, postingDTO?: IPostingDTO) {
        this.postingType = new PostingType();
        this.translations.push(new PostingTranslation());

        if (postingQuery) {
            this.id = postingQuery.id.toString();
            this.url = postingQuery.url;
            this.postingType = new PostingType(postingQuery.posting_type);
            this.validFrom = new Date(postingQuery.valid_from);
            this.validTo = postingQuery.valid_to ? new Date(postingQuery.valid_to) : null;
            this.createdBy = postingQuery.created_by && postingQuery.created_by.id != null ? new PostingCreatedBy(postingQuery.created_by) : null;
            this.createdAt = new Date(postingQuery.created_at);
            this.image = new MaxbrainImage(postingQuery.image);
            this.kind = postingQuery.kind;
            this.translations = postingQuery.translations ? postingQuery.translations.map((translation) => new PostingTranslation(translation)) : null;
            this.translation = postingQuery.translation ? postingQuery.translation : null;
            this.article = postingQuery.article ? { uniqueId: postingQuery.article.unique_id, id: postingQuery.article.id } : null;
        } else if (postingDTO) {
            this.postingType = new PostingType();

            if (postingDTO.articleId) {
                this.article = {
                    id: postingDTO.articleId,
                };
            }

            if (postingDTO.validFrom) {
                this.validFrom = postingDTO.validFrom;
            }
            if (postingDTO.validTo) {
                this.validTo = postingDTO.validTo;
            }

            this.postingType.id = postingDTO.postingType.type;

            if (postingDTO.image) {
                this.image = new MaxbrainImage(postingDTO.image);
            }

            this.kind = postingDTO.kind;

            this.url = postingDTO.url;

            this.translations = [];
            this.translations.push(postingDTO.translations);
        }
    }
}
